// Specification Sheets — in-page category filter.
//
// All cards live in the DOM (no pagination), so filtering just toggles card
// visibility. Chips are buttons; with JS off, every card is simply visible
// (the [hidden] state is only ever applied by this script), so the page still
// works fully unfiltered.
(function () {
  function init(root) {
    var filter = root.querySelector('[data-ss-filter]');
    var grid = root.querySelector('[data-ss-grid]');
    if (!filter || !grid) return;

    var chips = Array.prototype.slice.call(filter.querySelectorAll('[data-ss-chip]'));
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-ss-category]'));
    var countEl = root.querySelector('[data-ss-count]');
    var emptyEl = root.querySelector('[data-ss-empty]');
    if (!chips.length || !cards.length) return;

    function apply(cat, updateUrl) {
      var key = (cat || 'all').trim().toLowerCase();
      var shown = 0;

      cards.forEach(function (card) {
        var match = key === 'all' || (card.getAttribute('data-ss-category') || '').trim().toLowerCase() === key;
        card.hidden = !match;
        if (match) shown++;
      });

      chips.forEach(function (chip) {
        var isActive = (chip.getAttribute('data-ss-chip') || 'all').trim().toLowerCase() === key;
        chip.classList.toggle('is-active', isActive);
        if (isActive) { chip.setAttribute('aria-current', 'true'); }
        else { chip.removeAttribute('aria-current'); }
      });

      if (emptyEl) emptyEl.hidden = shown !== 0;
      if (countEl) {
        countEl.hidden = false;
        countEl.textContent = key === 'all'
          ? 'Showing all ' + cards.length + ' specification sheets'
          : 'Showing ' + shown + ' of ' + cards.length + ' specification sheets';
      }

      if (updateUrl && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        if (key === 'all') { url.searchParams.delete('category'); }
        else { url.searchParams.set('category', key); }
        history.replaceState({ category: key }, '', url.toString());
      }
    }

    filter.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-ss-chip]');
      if (!chip || !filter.contains(chip)) return;
      e.preventDefault();
      apply(chip.getAttribute('data-ss-chip'), true);
    });

    var initial = new URL(window.location.href).searchParams.get('category') || 'all';
    apply(initial, false);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ss-root]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
